import PropTypes from "prop-types";
import FormModal from "../../../../core/ui/components/FormModal";
import { useForm } from "react-hook-form";
import AreasTab from "../../../Personas/ui/components/FormPersonas/areas-tab";
import SubAreasContext from "../../../Personas/store/sub-areas-context";
import { useContext } from "react";
import { useEffect } from "react";
import { editarAsignacionDeSubAreas } from "../../../Actividades/services/actividades-service";

const FormCambiarSubArea = ({ onCambioArea, modalState }) => {
    const form = useForm({ defaultValues: { sedes: [] } });
    const { consultarPersonaHasSubArear, personaHasSubAreas, limpiarSubAreas } =
        useContext(SubAreasContext);

    useEffect(() => {
        if (modalState.show == false) return;
        consultarPersonaHasSubArear(modalState.data.personaId);
    }, [modalState.show]);

    const onSubmit = () => {
        const nuevasAreas = personaHasSubAreas.get("nuevas").entries();
        const crear = [];
        const eliminar = [];
        for (const nArea of nuevasAreas) {
            crear.push(nArea[1].sub_area_has_sede_id);
        }

        const eliminarAreas = personaHasSubAreas.get("aEliminar").entries();
        for (const eArea of eliminarAreas) {
            eliminar.push(eArea[1].sub_area_has_sede_id);
        }
        editarAsignacionDeSubAreas(modalState.data.personaId, crear, eliminar);
        onCambioArea();
        limpiarSubAreas();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            onSubmit={onSubmit}
            id="formCambiarSubArea"
            isOpen={modalState.show}
            closeModal={() => {
                modalState.close();
                limpiarSubAreas();
            }}
            headerTitle="Modificar sub areas"
        >
            <AreasTab
                errors={form.formState.errors}
                control={form.control}
                getValues={form.getValues}
                tipo="areasEditar"
            ></AreasTab>
        </FormModal>
    );
};

FormCambiarSubArea.propTypes = {
    onCambioArea: PropTypes.func,
    modalState: PropTypes.object,
};

export default FormCambiarSubArea;
